var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage2Line = function SvgMessage2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.51 18.3 3.5 21.45V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9zm-.623-1.8H19.7V5.7H5.3v12.047zm4.713-6.3h1.8V12h-1.8zm-3.6 0h1.8V12H8zm7.2 0H17V12h-1.8z"
  })));
};
export default SvgMessage2Line;